// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Mo1","questions":"styles_questions__3c_5g","footer":"styles_footer__13WjY"};